export default [
    {
        path: 'requisicao',
        component: () => import(/* weimunizacaockChunkName: 'imunizacao-requisicao' */ '@/views/imunizacao/requisicao/Index'),
        redirect: 'requisicao/index',
        children: [
            {
                name: 'imunizacao-requisicao-index',
                path: 'index',
                component: () => import(/* weimunizacaockChunkName: 'imunizacao-requisicao' */ '@/views/imunizacao/requisicao/List.vue'),
            },
            {
                name: 'imunizacao-requisicao-create',
                path: 'create',
                component: () => import(/* weimunizacaockChunkName: 'imunizacao-requisicao' */ '@/views/imunizacao/requisicao/Form.vue'),
            },
            {
                name: 'imunizacao-requisicao-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(/* weimunizacaockChunkName: 'imunizacao-requisicao' */ '@/views/imunizacao/requisicao/Form.vue'),
            },
        ],
    },
]